module.exports = __webpack_public_path__ + "img/img (9).09e68877.jpg";